<template>
  <div class="search-empty-wrapper">
    <div class="img-box" />
    <p class="label">未搜索到符合条件的视频</p>
    <p class="tag">可尝试更换关键词</p>
  </div>
</template>

<script>
export default {
  name: 'SearchEmpty'
}
</script>

<style scoped lang="scss">
.search-empty-wrapper {
  padding-top: 50px;
  text-align: center;
  .img-box {
    @include wh(170px, 170px);
    @include bg-image-png('/error/empty');
    @include bg-image-fit;
    margin: auto;
  }
  .label {
    @include ft($font-size-md, 14px);
    margin-top: 16px;
  }
  .tag {
    @include sc($font-size-md, $color-text-light);
    margin-top: 12px;
  }
}
</style>
